export default {
  // Reset Password Form
  setNewPassword: 'Definir Nova Senha',
  newPassword: 'Nova senha',
  confirmNewPassword: 'Confirmar nova senha',
  forgotPassword: 'Esqueceu sua senha?',
  passwordRequirementsTitle: 'Requisitos da Nova Senha',
  passwordRequirementsIntro: 'A nova senha deve:',
  passwordReqLength: 'Ter pelo menos 12 caracteres',
  passwordReqNumber: 'Incluir um número',
  passwordReqLowercase: 'Incluir uma letra minúscula',
  passwordReqUppercase: 'Incluir uma letra maiúscula',
  passwordReqSpecial: 'Incluir um caractere especial',
  passwordReqSpecialChars: '(#, ?, !, @, $, %, ^, *, -)',
  checkEmailForReset: 'Verifique seu e-mail para as instruções de redefinição de senha.',
  ok: 'OK',
  resetPassword: 'Redefinir senha',
  enterYourEmail: 'Digite seu e-mail',
  cancel: 'Cancelar',
  sendResetEmail: 'Enviar e-mail de redefinição',

  // Password Dialog (logged in)
  setANewPassword: 'Definir uma nova senha',
  currentPassword: 'Senha atual',
  repeatNewPassword: 'Repetir nova senha',
  proceed: 'Continuar',
  forgotCurrentPassword: 'Esqueceu sua senha atual? (enviaremos um e-mail)',
  passwordResetEmailSent: 'Você receberá um e-mail com instruções para redefinir sua senha nos próximos minutos.',

  // Terms & Conditions
  termsAndConditions: 'Termos e Condições',
  termsTitle: 'Termos e Condições de Uso',
  termsSection1Title: '1. Definições',
  termsSection1User: '"Usuário" significa um funcionário de uma empresa que celebrou um contrato com a NoiseGrasp para acessar os Serviços.',
  termsSection1Services: '"Serviços" significa a plataforma de Marketing Mix Modeling, ferramentas relacionadas, software e todas as funcionalidades associadas fornecidas pela NoiseGrasp.',
  termsSection2Title: '2. Aceitação dos Termos',
  termsSection2Content: 'Ao acessar e utilizar os Serviços, o Usuário aceita e concorda em ficar vinculado pelos termos e disposições deste acordo. O acesso aos Serviços é fornecido sob o contrato entre a empresa do Usuário e a NoiseGrasp.',
  termsSection3Title: '3. Restrições',
  termsSection3Intro: 'O Usuário não deverá (e não autorizará terceiros a):',
  termsSection3Item1: 'modificar, traduzir, fazer engenharia reversa, descompilar, desmontar ou criar trabalhos derivados baseados nos Serviços, exceto na medida em que a aplicação da restrição anterior seja proibida pela lei aplicável;',
  termsSection3Item2: 'contornar quaisquer limites ou outras restrições de tempo, uso ou funcionalidade incorporadas nos Serviços;',
  termsSection3Item3: 'remover quaisquer avisos de propriedade, etiquetas ou marcas dos Serviços.',
  termsSection4Title: '4. Responsabilidades de Segurança do Usuário',
  termsSection4Intro: 'O Usuário é responsável por manter a segurança e confidencialidade de suas credenciais de conta e informações de acesso. O Usuário deve:',
  termsSection4Item1: 'manter todas as credenciais de login seguras e confidenciais;',
  termsSection4Item2: 'não compartilhar o acesso à conta com pessoas não autorizadas;',
  termsSection4Item3: 'notificar imediatamente a NoiseGrasp sobre qualquer suspeita de violação de segurança ou acesso não autorizado à sua conta;',
  termsSection4Item4: 'ser responsável por todas as atividades que ocorram em sua conta.',
  termsSection5Title: '5. Propriedade e Direitos de Propriedade',
  termsSection5Content1: 'A NoiseGrasp possui e reterá todos os direitos, títulos e interesses (incluindo, sem limitação, todos os direitos de patente, direitos autorais, direitos de marca registrada, direitos de segredo comercial e outros direitos de propriedade intelectual) sobre os Serviços. O Usuário concorda que apenas a NoiseGrasp terá o direito de manter, melhorar ou modificar de outra forma os Serviços.',
  termsSection5Content2: 'Se o Usuário fornecer à NoiseGrasp relatórios de defeitos nos Serviços ou propor ou sugerir quaisquer alterações ou modificações (coletivamente "Feedback"), a NoiseGrasp terá o direito de usar e explorar tal Feedback incluindo, sem limitação, a incorporação de tal Feedback nos produtos e/ou serviços de software da NoiseGrasp, incluindo, sem limitação, os Serviços, sem qualquer obrigação para com o Usuário. A NoiseGrasp reserva todos os direitos e não concede ao Usuário nenhuma licença de qualquer tipo, seja por implicação, impedimento legal ou de outra forma.',
  termsSection6Title: '6. Uso Comercial',
  termsSection6Content: 'Estes Serviços são fornecidos para uso comercial por funcionários de empresas que contrataram com a NoiseGrasp. Estes Termos e Condições fazem parte de um contrato mais amplo assinado entre as empresas e a NoiseGrasp.',
  termsSection7Title: '7. Privacidade de Dados',
  termsSection7Intro: 'A NoiseGrasp está comprometida com a proteção da privacidade do Usuário. Nossas práticas de coleta de dados são mínimas e limitadas a:',
  termsSection7Item1: 'Endereços de e-mail e nomes de usuário, que servem apenas como identificação;',
  termsSection7Item2: 'cookies essenciais necessários para o funcionamento adequado dos Serviços;',
  termsSection7Item3: 'sem rastreamento de informações pessoais nem monitoramento de comportamento;',
  termsSection7Item4: 'sem uso de cookies de rastreamento nem coleta de dados pessoais além do necessário para a operação do sistema.',
  termsSection7Content: 'Todos os dados carregados e processados através dos Serviços são tratados de acordo com as regulamentações de proteção de dados aplicáveis.',
  termsSection8Title: '8. Limitações',
  termsSection8Content1: 'A NoiseGrasp se compromete a fornecer serviços com o devido cuidado, diligência e adesão às melhores práticas e padrões da indústria. No entanto, fica explicitamente estabelecido que os modelos e entregáveis resultantes da análise de dados fornecidos pelo Usuário e/ou sua empresa são derivados de estimativas e da aplicação de modelos matemáticos complexos. As conclusões e resultados obtidos desses modelos não são garantidos.',
  termsSection8Content2: 'Além disso, a NoiseGrasp afirma que todos os modelos matemáticos fornecidos a seus clientes são estimativas baseadas em dados e algoritmos matemáticos. Nenhuma garantia, expressa ou implícita, é feita com relação à adequação desses modelos para alcançar qualquer resultado específico. A NoiseGrasp renuncia a qualquer responsabilidade pela precisão ou confiabilidade dos resultados obtidos através da utilização de seus modelos matemáticos. O Usuário reconhece que qualquer confiança em tais resultados é por sua própria conta e risco.',
  termsSection8Content3: 'Por sua vez, o Usuário reconhece que o uso de modelos matemáticos inerentemente envolve incertezas e variações potenciais nos resultados. Além disso, o Usuário concorda em utilizar os modelos por sua própria conta e risco, entendendo que a NoiseGrasp não será responsável por quaisquer consequências decorrentes de tal uso.',
  termsSection9Title: '9. Modificações',
  termsSection9Content: 'Ao usar os Serviços, o Usuário concorda em ficar vinculado a estes Termos e Condições de Uso. Se os Termos e Condições mudarem no futuro, este aviso será atualizado de acordo.',
  termsLastUpdated: 'Última atualização: 15/07/2025',
  acceptTerms: 'Aceitar Termos e Condições',
  close: 'Fechar',

  // What's New Dialog
  whatsNew: 'Novidades',
  posted: 'Publicado {time}',
  previous: 'Anterior',
  next: 'Próximo',
  ofCount: '({current} de {total})',

  // Model Selection Dialog
  modelSelection: 'Seleção de Modelo',
  allCountries: 'Todos os países',
  countriesSelected: '{count} de {total} países selecionados',
  filterByCountry: 'Filtrar por País',
  searchCountries: 'Buscar países',
  selectAll: 'Selecionar Tudo',
  selectAllVisible: 'Selecionar Todos os Visíveis ({count})',
  allBrands: 'Todas as marcas',
  brandsSelected: '{count} de {total} marcas selecionadas',
  filterByBrand: 'Filtrar por Marca',
  searchBrands: 'Buscar marcas',
  allClients: 'Todos os clientes',
  clientsSelected: '{count} de {total} clientes selecionados',
  filterByClient: 'Filtrar por Cliente',
  searchClients: 'Buscar clientes',
  allCategories: 'Todas as categorias',
  categoriesSelected: '{count} de {total} categorias selecionadas',
  filterByCategory: 'Filtrar por Categoria',
  searchCategories: 'Buscar categorias',
  allSubcategories: 'Todas as subcategorias',
  subcategoriesSelected: '{count} de {total} subcategorias selecionadas',
  filterBySubcategory: 'Filtrar por Subcategoria',
  searchSubcategories: 'Buscar subcategorias',
  search: 'Buscar',
  adHocModels: 'MODELOS AD-HOC',
  customModels: 'MODELOS PERSONALIZADOS',
  select: 'Selecionar',
  deployed: 'Implantado',
  notAvailable: 'N/D',

  // Table Headers
  headerModelName: 'Nome do Modelo',
  headerBrand: 'Marca',
  headerCountry: 'País',
  current: 'atual',
  versionDeployed: 'Implantada em {date}',
  headerClient: 'Cliente',
  headerCategory: 'Categoria',
  headerSubcategory: 'Subcategoria',
  headerReference: 'Referência',
  headerDateCreated: 'Data de Criação',
  headerDateModified: 'Data de Modificação',
  headerCreatedBy: 'Criado por',

  // Navigation Menu
  currentModel: 'Modelo Atual',
  home: 'Início',
  modelSetup: 'Modelo',
  dataUpload: 'Upload de Dados',
  dataCheck: 'Revisão de Dados',
  modelingProcess: 'Progresso',
  modelReport: 'Relatório do Modelo',
  modelOverview: 'Visão Geral do Modelo',
  whatIfScenario: 'Cenário Hipotético',
  mediaPlanner: 'Planejador',
  planCalculator: 'Calculadora',
  planOptimizer: 'Otimizador',
  budgetSimulator: 'Simulador de Orçamento',
  documents: 'Documentos',
  admin: 'Admin',
  users: 'Usuários',
  refModels: 'Modelos Ref.',
  adHocModelsMenu: 'Modelos Ad-Hoc',
  countries: 'Países',
  news: 'Notícias',
  pendingPlans: 'Planos Pendentes',
  aiReviews: 'Revisões IA',
  errorLogs: 'Logs de Erros',
  automaticModels: 'DIY Models',
  automaticModeler: 'DIY Modeler',
  modelFactory: 'Model Factory',
  modelComposer: 'Model Composer',
  ekrmManager: 'Gerenciador EKRM',
  userManager: 'Gerenciador Usuários',
  modelManager: 'Gerenciador Modelos',
  learningCenter: 'Central de Aprendizado',
  stats: 'Estatísticas',
  tools: 'Ferramentas',
  logout: 'Sair',

  // Notifications
  clearAllNotifications: 'Limpar todas as notificações',
  mediaPlanReady: 'O Plano de Mídia está pronto',
  modelReportReady: 'O Relatório do Modelo está pronto',
  ekrmReady: 'EKRM está pronto',
  whatIfScenarioReady: 'O Cenário Hipotético está pronto',
  budgetSimulationReady: 'A Simulação de Orçamento está pronta',
  noUnreadNotifications: 'Não há notificações não lidas',

  // Login Screen
  login: 'Entrar',
  email: 'E-mail',
  password: 'Senha',
  loginWithGoogle: 'Entrar com Google',

  // Loading States
  loading: 'Carregando...',
  authenticatingUser: 'Autenticando usuário...',
  clickToSignIn: 'Clique aqui para entrar com Lion Login',

  // Validation Messages
  required: 'Obrigatório.',
  wrongPassword: 'Senha incorreta',
  passwordsMustMatch: 'As novas senhas devem coincidir',
  passwordMustBeDifferent: 'A nova senha deve ser diferente da anterior',
  passwordRequirements: 'A senha deve ter mais de 12 caracteres e deve conter caracteres numéricos, minúsculos, maiúsculos e especiais (#, ?, !, @, $, %, ^, *, -)',

  // Alert Messages
  passwordSetSuccessfully: 'Senha definida com sucesso',
  internalError: 'Erro interno, por favor entre em contato com o administrador do sistema. Código de erro: ',

  // Time Ago
  justNow: 'agora mesmo',
  yearsAgo: 'há {count} ano | há {count} anos',
  monthsAgo: 'há {count} mês | há {count} meses',
  daysAgo: 'há {count} dia | há {count} dias',
  hoursAgo: 'há {count} hora | há {count} horas',
  minutesAgo: 'há {count} minuto | há {count} minutos',
  secondsAgo: 'há {count} segundo | há {count} segundos',

  // Driver.js Intro Tour
  introCurrentModelTitle: 'Modelo Atual',
  introCurrentModelDesc: 'Selecione qual Modelo Personalizado usar para trabalhar com o Relatório do Modelo e o Simulador Online.',
  introModelReportTitle: 'Relatório do Modelo',
  introModelReportDesc: 'Visualize um relatório que mostra o Gasto em Marketing estimado e KPI para o Modelo Atual. Este relatório é calculado com base no Modelo de Referência especificado na criação do modelo.',
  introMediaPlannerTitle: 'Planejador de Mídia',
  introMediaPlannerDesc: 'Execute Simulações e Otimizações. Visualize KPI Simulado e KPI Otimizado para o: Período, Orçamento, Restrições de Mídia/Pontos de Contato e Prioridades de Segmento especificados.',
  introModelManagerTitle: 'Gerenciador de Modelos',
  introModelManagerDesc: 'Crie Modelos Personalizados baseados em qualquer um dos Modelos de Referência disponíveis e em dados específicos do cliente utilizados para ajustá-los.',
  introModelDeletedTitle: 'Modelo Excluído',
  introModelDeletedDesc: 'O modelo que você tinha selecionado acabou de ser excluído. Por favor selecione outro.',

  // Footer Copyright
  poweredBy: 'Desenvolvido por ',
  allRightsReserved: 'Todos os direitos reservados - '
}
